import { render } from "./fbx-input-icon.vue?vue&type=template&id=0a8d5633&scoped=true&ts=true"
import script from "./fbx-input-icon.vue?vue&type=script&lang=ts"
export * from "./fbx-input-icon.vue?vue&type=script&lang=ts"

import "./fbx-input-icon.vue?vue&type=style&index=0&id=0a8d5633&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8d5633"]])

export default __exports__